import { isProduction, isTestingEnv } from '../env.utils';

export interface IDatalayerGTM {
  event: string;
  action?: any;
  ecommerce?: any;
}

interface IPendingEvent {
  data: IDatalayerGTM;
  cleanKey?: string;
}

const MAX_PENDING_GTM_EVENTS = 50;
const SESSION_TIMEOUT_MS = 10 * 60 * 1000;

let userPropertiesReady = false;
let lastUserPropertiesAt = new Date();
let pendingEvents: Array<IPendingEvent> = [];
let lastLoginStatusEvent: IDatalayerGTM = { event: '' };

const getOrCreateDataLayer = () => {
  if (!globalThis.dataLayer) {
    globalThis.dataLayer = [];
  }

  return globalThis.dataLayer;
};

export const markUserPropertiesReady = () => {
  userPropertiesReady = true;
};

export const resetUserPropertiesReady = () => {
  userPropertiesReady = false;
  pendingEvents = [];
  lastLoginStatusEvent = { event: '' };
  lastUserPropertiesAt = new Date();
};

const queueEvent = (pendingEvent: IPendingEvent) => {
  if (pendingEvents.length >= MAX_PENDING_GTM_EVENTS) {
    pendingEvents.shift();
  }

  pendingEvents.push(pendingEvent);
};

const isSessionExpired = () => new Date().getTime() - lastUserPropertiesAt.getTime() > SESSION_TIMEOUT_MS;

const updateUserPropertiesSnapshot = (data: IDatalayerGTM) => {
  if (data.event !== 'login_Status') return;

  lastLoginStatusEvent = data;
  lastUserPropertiesAt = new Date();
};

const replayUserPropertiesAndFlush = (data: IDatalayerGTM, cleanKey?: string) => {
  pushObjectDataLayer(lastLoginStatusEvent);
  queueEvent({ data, cleanKey });
  flushPendingEvents();
};

export const pushObjectDataLayer = (data: IDatalayerGTM, cleanKey?: string) => {
  const dataLayer = getOrCreateDataLayer();

  // * LOG to track GTM event only if not production
  // eslint-disable-next-line no-console
  if (!isProduction() && !isTestingEnv()) console.log(`Enviando al GTM (evento: ${data.event}):`, data);
  if (cleanKey) dataLayer.push({ [cleanKey]: null });
  updateUserPropertiesSnapshot(data);
  dataLayer.push(data);
};

export const pushOrQueueEvent = (data: IDatalayerGTM, cleanKey?: string) => {
  if (!userPropertiesReady) {
    queueEvent({ data, cleanKey });
    return;
  }

  if (isSessionExpired()) {
    replayUserPropertiesAndFlush(data, cleanKey);
    return;
  }

  pushObjectDataLayer(data, cleanKey);
};

export const flushPendingEvents = () => {
  if (!userPropertiesReady || pendingEvents.length === 0) return;

  const eventsToFlush = [...pendingEvents];
  pendingEvents = [];

  eventsToFlush.forEach(({ data, cleanKey }) => {
    pushObjectDataLayer(data, cleanKey);
  });
};
